import { useEffect } from 'react';

const useEnterNavigation = (isEnabled = true) => {
  useEffect(() => {
    if (!isEnabled) return;

    const handleKeyDown = (event) => {
      // Enter tuşuna basıldığında
      if (event.key === 'Enter') {
        const activeElement = document.activeElement;
        
        // Eğer aktif element bir input, select veya textarea ise
        if (activeElement && (
          activeElement.tagName === 'INPUT' || 
          activeElement.tagName === 'SELECT' || 
          activeElement.tagName === 'TEXTAREA'
        )) {
          // Submit button değilse ve multiline textarea değilse
          if (activeElement.type !== 'submit' && 
              activeElement.type !== 'button' &&
              !(activeElement.tagName === 'TEXTAREA' && !event.shiftKey)) {
            
            event.preventDefault();
            
            // Tüm focusable elementleri bul
            const focusableElements = document.querySelectorAll(
              'input:not([disabled]):not([type="hidden"]), ' +
              'select:not([disabled]), ' +
              'textarea:not([disabled]), ' +
              'button:not([disabled]), ' +
              '[tabindex]:not([tabindex="-1"]):not([disabled])'
            );
            
            const focusableArray = Array.from(focusableElements);
            const currentIndex = focusableArray.indexOf(activeElement);
            
            // Bir sonraki elementi bul
            if (currentIndex !== -1 && currentIndex < focusableArray.length - 1) {
              const nextElement = focusableArray[currentIndex + 1];
              nextElement.focus();
              
              // Eğer input ise içeriği seç
              if (nextElement.tagName === 'INPUT' && nextElement.type === 'text') {
                nextElement.select();
              }
            }
          }
        }
      }
    };

    // Event listener ekle
    document.addEventListener('keydown', handleKeyDown);
    
    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isEnabled]);
};

export default useEnterNavigation; 